const urlUtil = {
    //从url中获取参数值
    getval(url, name) {
        const reg = new RegExp("(^|\\?|&)" + name + "=([^&|#]*)(\\s|&|#|$)", "i");  // 因为vue有添加“#”的特点，所以这里的正则表达式会匹配 & -- &/#
        if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
        return "";
    }
};

export default urlUtil;